import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_CHILDDEVICE_DETAILS } from './url-constants';

type StarfishChildDeviceUpdateEndpointSpecification = ApiEndpointSpecification;
export const StarfishChildDeviceUpdateEndpointSpecification: StarfishChildDeviceUpdateEndpointSpecification = {
    url: STARFISH_CHILDDEVICE_DETAILS,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'StarfishChildDeviceUpdateRequestParams',
    requestBodySchemaName: 'StarfishChildDeviceUpdateRequestBody',
    okResponseSchemaName: 'StarfishChildDeviceUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeStarfishChildDeviceUpdate = Helpers.makeApiRequestFn<
    Types.StarfishChildDeviceUpdateRequestParams,
    Types.StarfishChildDeviceUpdateRequestBody,
    Types.StarfishChildDeviceUpdateOkResponse
>(StarfishChildDeviceUpdateEndpointSpecification);
